module.exports = __webpack_public_path__ + "static/media/delete.2dc8c30b.svg";